import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getDisplayName } from 'utils/hocHelpers';
import RouteLeavingGuard from 'components/routeLeavingGuard/RouteLeavingGuard';
import Prompt from 'components/Prompt/PromptComponent';
import { areObjectsEqual, getTransformedObject } from 'utils/objectUtils';

// This HOC blocks navigation with react router by checking if there are any errors in location state
// or if there are values within data (from Glu's FormProvider)
// Also checks if formData state has an allowNavigation property

const WithFormPromptWrapper = (modal) => (WrappedComponent) => {
  const WithFormPrompt = ({ data: formData, ...props }) => {
    const [initialState, setInitialState] = useState(formData);
    const [filled, setFilled] = useState(false);

    const shouldBlockNavigation = (location) => {
      const getPathname = location?.pathname;
      // allow to exclude some path from display modal
      const exclude = location?.state?.excludePathname || '';
      const excluded = getPathname === exclude;
      const hasError = location?.state?.errorMessage;

      if (hasError) {
        return false;
      }

      return !formData.allowNavigation && !excluded && !areObjectsEqual(initialState, formData);
    };

    useEffect(() => {
      const initDataToCompare = getTransformedObject(initialState);
      const formDataToCompare = getTransformedObject(formData);
      if (!filled && !areObjectsEqual(initDataToCompare, formDataToCompare)) {
        setInitialState(formData);
        setFilled(true);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData, filled]);

    return (
      <>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <WrappedComponent data={formData} {...props} />
        <RouteLeavingGuard shouldBlockNavigation={shouldBlockNavigation}>
          {modal || Prompt}
        </RouteLeavingGuard>
      </>
    );
  };
  WithFormPrompt.displayName = `WithFormPrompt(${getDisplayName(WrappedComponent)})`;
  WithFormPrompt.propTypes = {
    data: PropTypes.shape({}),
    exclude: PropTypes.arrayOf(PropTypes.string)
  };
  WithFormPrompt.defaultProps = {
    data: {},
    exclude: []
  };
  return WithFormPrompt;
};

export default WithFormPromptWrapper;
